document.addEventListener("DOMContentLoaded", function () {
    var doto_announcement_slider = new Swiper(".doto_announcement_slider", {
        spaceBetween: 0,
        slidesPerView: 1,
        centeredSlides: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        }
    });   


    var doto_product_slider = new Swiper(".doto_product_slider", {
        spaceBetween: 20,
        slidesPerView: 1.08,
        // slidesOffsetAfter:20,
        mousewheel: { forceToAxis: !0, sensitivity: 1, releaseOnEdges: !0 },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            0: {
                spaceBetween: 20,
                slidesPerView: 1,
                // slidesPerView: 1.13,
                // slidesOffsetAfter:20,
            },
            576: {
                spaceBetween: 24,
                slidesPerView: 2,
                // slidesPerView: 2.08,
                // slidesOffsetAfter:24,
            },
            768: {
                spaceBetween: 24,
                slidesPerView: 2,
                // slidesPerView: 2.8,
                // slidesOffsetAfter:24,
            },
            1080: {
                spaceBetween: 24,
                slidesPerView: 3,
                // slidesPerView: 3.5,
                // slidesOffsetAfter:24,
            }
        }
    });

  document.querySelectorAll("ul.doto_tabs li").forEach(function (tab) {
    tab.addEventListener("click", function () {
      var tab_id = this.getAttribute("data-tab");
      var parent = this.closest(".doto_range_hood_section");
      
      parent.querySelectorAll("ul.doto_tabs li").forEach(function (el) {
        el.classList.remove("current");
      });
      parent.querySelectorAll(".doto_product_main").forEach(function (el) {
        el.classList.remove("current");
      });
      this.classList.add("current");
      // document.getElementById(tab_id).classList.add("current");
      parent.querySelector("#"+tab_id).classList.add("current");
    });
  });


  const tabLinks = document.querySelectorAll('.doto_category_block');
    tabLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = link.getAttribute('href').replace('#', '');
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          document.querySelectorAll('.doto_category_block').forEach(tab => {
            tab.classList.remove('is-active');
          });
          link.classList.add('is-active');
          const headerHeight = document.querySelector('.header-wrapper')?.offsetHeight || 0;
          const announcementHeight = document.querySelector('.announcement-bar')?.offsetHeight || 0;
          const totalOffset = headerHeight + announcementHeight;
          const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - totalOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });


});